import { defaultTFormV2 } from "../models/TForm";
import * as SendMagicLink1 from "../../../domain/models/SendMagicLink1";
import {
    TSendMagicLink1Form,
} from "./../models/TFormModels";

export class C {
    resendLinkForm: TSendMagicLink1Form = defaultTFormV2({}, SendMagicLink1.newDefault(), {}, "success");
}
